import { useEffect, useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import TextComponent from 'components/Input/TextComponent';

/** 本日日付を yyyy/MM/dd 形式で取得する */
export const getToday = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = ('0' + (now.getMonth() + 1)).slice(-2);
  const day = ('0' + now.getDate()).slice(-2);
  return `${year}/${month}/${day}`;
};

/** 見積日を yyyy/MM/dd 形式に揃える */
const normalizeDate = (value) => String(value ?? '').replace(/-/g, '/').trim();

/**
 * 印刷・ダウンロード時に見積日を選択するモーダル
 *
 * props.params に以下を渡すと表示される（表示のたびに新しいオブジェクトを渡すこと）
 *   mitsuDate : 登録済みの見積日（yyyy/MM/dd）。初期表示値になる
 *   label     : 日付欄のラベル。既定は「見積日」
 *   callBack  : (mitsuDate) => void  確定時に呼ばれる
 */
export const PrintDateModal = (props) => {
  const [show, setShow] = useState(false);
  // 入力中の見積日
  const [mitsuDate, setMitsuDate] = useState('');
  // 「本日日付にする」のチェック状態
  const [checkedToday, setCheckedToday] = useState(false);

  // パラメタが渡されたら、登録済みの見積日を初期値にして開く
  useEffect(() => {
    if (!props.params?.callBack) {
      return;
    }
    setMitsuDate(normalizeDate(props.params.mitsuDate));
    setCheckedToday(false);
    setShow(true);
  }, [props.params]);

  const label = props.params?.label ?? '見積日';

  // 「本日日付にする」の切り替え
  const handleChangeToday = (checked) => {
    setCheckedToday(checked);
    // チェック時は本日日付、外した場合は登録済みの見積日に戻す
    setMitsuDate(checked ? getToday() : normalizeDate(props.params?.mitsuDate));
  };

  // 日付の変更
  const handleChangeDate = (target) => {
    const value = normalizeDate(target?.value ?? target?.target?.value);
    setMitsuDate(value);
    // 「本日日付にする」で日付を書き換えた場合もカレンダー側から変更が通知されるため、
    // 本日以外の日付が選ばれたときだけチェックを外す
    if (value != getToday()) {
      setCheckedToday(false);
    }
  };

  // 閉じるボタン
  const handleClose = () => {
    setShow(false);
  };

  // 確定ボタン
  const handleFix = () => {
    setShow(false);
    props.params?.callBack && props.params.callBack(mitsuDate);
  };

  return (
    <Dialog
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '560px',
          },
        },
      }}
      open={show}
      disableEnforceFocus={true}
    >
      <DialogTitle className="p-3">{label}の選択</DialogTitle>
      <DialogContent className="px-0 py-0 pr-0 pl-0">
        <Card className="m-0">
          <Card.Body>
            <Row className="pl-2 pt-2">
              <Col md="5">
                <label>{label}</label>
              </Col>
            </Row>
            <Row className="pt-1 align-items-center">
              <Col md="5">
                <TextComponent
                  type="date"
                  value={mitsuDate}
                  onChange={handleChangeDate}
                ></TextComponent>
              </Col>
              <Col className="pl-1" md="7">
                <label className="mb-0" style={{ fontSize: '14pt', color: 'black' }}>
                  <input
                    className="mr-2"
                    style={{ transform: 'scale(1.5)' }}
                    type="checkbox"
                    checked={checkedToday}
                    onChange={(e) => handleChangeToday(e.target.checked)}
                  ></input>
                  本日日付にする
                </label>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </DialogContent>
      <DialogActions className="p-3" style={{ justifyContent: 'space-between' }}>
        <Button variant="secondary" className="footer-button" onClick={handleClose}>
          閉じる
        </Button>
        <Button
          variant="primary btn-fill"
          className="footer-button"
          disabled={!mitsuDate}
          onClick={handleFix}
        >
          確定
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrintDateModal;
